import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { AuthResultVM } from '../viewmodels/ISearchService';
import { mergeMap as _observableMergeMap, catchError as _observableCatch, map } from 'rxjs/operators';
import Swal from 'sweetalert2';


@Injectable()
export class AuthenticationService {
  myAppUrl: string = "";
  uid: string = "";
  pwd; string = "";
  guid: string = "";
  msg: string = "";
  success: number = 0;
  auth: AuthResultVM = new AuthResultVM();
  loginLink: string = "Login";
  newPwd: string = "";
  confirmPwd: string = "";
  isLoggedIn: boolean = false;
  loginLinkChange: Subject<string> = new Subject<string>();
  showLogin: boolean = true;
  accountStatementPdf: any;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
    //  this.auth = new AuthResultVM();
    this.loginLinkChange.subscribe((value) => {
      this.loginLink = value
    });
  //  if (localStorage.getItem("machineLocation") === '0')
  //    this.showLogin = true;
  }

  async getCredentials() {
    //this.userInputVisible = true;   

    if (this.loginLink != "Login") {
      Swal.fire('Logged in as', this.uid);
      return;
    }

    let x = await Swal.fire({
      title: 'Login',
      showCancelButton: true,
      allowEnterKey: true,
      html:
        '<label for="uid" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Account #/User </label><input id="uid" type="text"><br/>' +
        '<label for="pwd" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Password </label><input id="pwd" type="password">',
      focusConfirm: true,
      preConfirm: () => {
//        (<HTMLInputElement>document.getElementById('uid')).focus;
        return [
          this.uid = (<HTMLInputElement>document.getElementById('uid')).value,
          this.pwd = (<HTMLInputElement>document.getElementById('pwd')).value
        ]
      }
    }).then((result) => {
      if (result.dismiss === undefined) {
        console.log('login ok');
//        if (this.uid.length > 0) {
////          this.AuthenticateUser();
        //        }
      }
      else {
        console.log('cancel log');
        return;
      }
    });

    if (this.uid.length > 0) {
      await this.AuthenticateUser();
    }

  }

  async setupUser() {

    if (this.success === 1) {

      console.log('success');
      localStorage.setItem('uid', this.uid);
      localStorage.setItem('guid', this.guid);
      //      Swal.fire(localStorage.getItem('guid'));
      this.loginLink = this.uid;
      this.isLoggedIn = true;
      console.log(localStorage.getItem('guid'));
//      console.log(this.guid);
    }
    else {
      console.log('failure');
      localStorage.removeItem('uid');
      localStorage.removeItem('guid');
      this.loginLink = "Login";
      this.isLoggedIn = false;
      Swal.fire('Failure', this.auth.msg);
    }
    this.loginLinkChange.next(this.loginLink);

  }


  async AuthenticateUser() {

    let x = "";
    let url = this.myAppUrl + 'api/CoreData/GetCredentials?uid=' + this.uid + '&pwd=' + this.pwd + '&loc=' + localStorage.getItem("machineLocation");

    await this._http.get<AuthResultVM>(url)
      .toPromise()
      .then(data => {
        this.auth = data;
        this.success = data.success;
        this.msg = data.msg;
        this.guid = data.credentialGuid;
        console.log('auth  - ' + this.success);
      });

    //if (this.success === 1)
    await this.setupUser();
  }

  async ValidateGuid() {

    var isValid: boolean = false;
    this.success = 0;
    this.uid = localStorage.getItem('uid');
    this.guid = localStorage.getItem('guid');

    if (this.guid === null) {
      this.loginLink = "Login";
      this.isLoggedIn = false;
    }
    else {
  
      await this._http.get<AuthResultVM>(this.myAppUrl + 'api/CoreData/ValidateGuid?guid=' + this.guid)
        .toPromise()
        .then(res => {
          this.success = res.success
          //console.log('auth 1 - ' + this.success);
        });
            //console.log('auth 2 - ' + this.success);

      if (this.success === 0) {
        this.loginLink = "Login";
        this.isLoggedIn = false;
      } else
        this.isLoggedIn = true;

    }

  }

  async logout() {

    Swal.fire({
      title: 'Logout?',
      showCancelButton: true
      //        confirmButtonText: 'OK'
    }).then((result) => {
      if (result.value === true) {
        localStorage.removeItem('uid');
        localStorage.removeItem('guid');
        this.loginLink = "Login";
        this.isLoggedIn = false;
      }
    })

    this.loginLinkChange.next(this.loginLink);
  }

  async autoLogout() {

    localStorage.removeItem('uid');
    localStorage.removeItem('guid');
    this.loginLink = "Login";
    this.isLoggedIn = false;

  }



  async changePassword() {

    this.uid = localStorage.getItem('uid');
    if (this.uid === null || this.uid.length === 0)
      return;

    let x = await Swal.fire({
      title: 'Change Password for ' + this.uid,
      showCancelButton: true,
      allowEnterKey: true,
      html:
        '<label for="pwd" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Password </label><input id="pwd" type="password"><br/>' +
        '<label for="newPwd" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">New Password </label><input id="newPwd" type="password">' +
        '<label for="confirmPwd" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Confirm Password </label><input id="confirmPwd" type="password">',
      focusConfirm: true,
      preConfirm: () => {
        (<HTMLInputElement>document.getElementById('pwd')).focus;
        return [
          this.pwd = (<HTMLInputElement>document.getElementById('uid')).value,
          this.newPwd = (<HTMLInputElement>document.getElementById('newPwd')).value,
          this.confirmPwd = (<HTMLInputElement>document.getElementById('confirmPwd')).value
        ]
      }
    }).then((result) => {

      console.log('result - ' + result.value);
      console.log(this.confirmPwd);

    //  if (result.value === true) {

    //    if (this.newPwd != this.confirmPwd) {
    //      Swal.fire('Error', 'Passwords do not match');
    //      return;
    //    }
    //    if (this.pwd.length === 0) {
    //      Swal.fire('Error', 'Passwords cannot be blank');
    //      return;
    //    }

    //    if (this.newPwd != this.pwd) {
    //      Swal.fire('Error', 'Password must be different');
    //      return;
    //    }

    //    this.resetPassword();
    //  }
    });
    //this.resetPassword();
  }

  async resetPassword() {
    console.log('reset');

    await this._http.get<AuthResultVM>(this.myAppUrl + 'api/CoreData/ResetPassword?uid=' + this.uid + '&pwd=' + this.pwd + '&newPwd=' + this.newPwd)
      .toPromise()
      .then(res => {
        this.success = res.success
        //console.log('auth 1 - ' + this.success);
      });

    if (this.success = 1)
      Swal.fire('Success', 'Password changed');

  }

  async getAccountActivity() {

    let year = new Date().getFullYear().toString();
    let month = (1 + new Date().getMonth()).toString();
    let day = new Date().getDate().toString();
    if (month.length === 1)
      month = '0' + month;
    if (day.length === 1)
      day = '0' + day;
    let fDate = month + '/' + '01' + '/' + year;
    let tDate = month + '/' + day + '/' + year;

    let x = await Swal.fire({
      title: 'Enter Date Range of Activity',
      showCancelButton: true,
      allowEnterKey: true,
      html:
        '<label for="fDate" style="display: inline-block; width: 100px; text-align: right; padding-right: 5px;">Date From </label><input id="fDate" type="text" value="' + fDate + '"><br/>' +
        '<label for="tDate" style="display: inline-block; width: 100px; text-align: right; padding-right: 5px;">Through date </label><input id="tDate" type="text" value="' + tDate + '">',
      focusConfirm: true,
      preConfirm: () => {
        //        (<HTMLInputElement>document.getElementById('uid')).focus;
        return [
          fDate = (<HTMLInputElement>document.getElementById('fDate')).value,
          tDate = (<HTMLInputElement>document.getElementById('tDate')).value
        ]
      }
    }).then((result) => {
      if (result.dismiss === undefined) {
        //ok button
        console.log('activity ok');
        if (Number.isNaN(Date.parse(fDate)) || Number.isNaN(Date.parse(tDate)))
          Swal.fire('Invaid Date Entered');
        else if (Date.parse(fDate) > Date.parse(tDate))
          Swal.fire("Invalid Date Range");
        else
          //kick off the report
          this.getAccountStatement(this.uid, fDate, tDate)
      }
      else {
        console.log('cancel activity');
        return;
      }
    });

  }

  async getAccountStatement(uid: string, fDate: string, tDate: string) {

    console.log('getAccountStatement');
    let url = this.myAppUrl + 'api/CoreData/GetAccountStatement?uid=' + uid + '&fDate=' + fDate + '&tDate=' + tDate;
    //console.log(url );

    this._http.get<any>(url).subscribe(
      (data => {
        console.log(data);
        console.log(Object.keys(data));

        let base64String = data._buffer;

        let byteChar = atob(base64String);
        let byteArray = new Array(byteChar.length);
        for (let i = 0; i < byteChar.length; i++) {
          byteArray[i] = byteChar.charCodeAt(i);
        }
        let uIntArray = new Uint8Array(byteArray);
        let file = new Blob([uIntArray], { type: 'application/pdf' });

        //var file = new Blob([data], { type: 'application/pdf' });
        //var file = new File([data], "MyCarrollCountyStatement.pdf", { type: 'application/pdf' });

        //download the pdf
        if (file.size != 0) {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, "MyCarrollCountyStatement.pdf");
          }
          // other browsers
          else {

            var a = document.createElement("a");
            document.body.appendChild(a);
            const url = window.URL.createObjectURL(file);
            //window.open(url);
            a.href = url;
            a.download = "MyCarrollCountyStatement.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          }

          Swal.fire('Download Complete', 'Check your downloads folder for a file named MyCarrollCountyStatement.PDF')

        }
      })
    );

  }

  //async getAccountStatementPdf(uid: string, fDate: string, tDate: string): Observable <any> {

  //  const search = { 'uid': uid, 'fDate': fDate, 'tDate': tDate};
  //  let url_ = this.myAppUrl + "api/CoreData/GetAccountStatement";
  //  url_ = url_.replace(/[?&]$/, "");
  //  const content_ = JSON.stringify(search);

  //  let options_: any = {
  //    body: content_,
  //    observe: "response",
  //    responseType: "blob",
  //    headers: new HttpHeaders({
  //      "Content-Type": "application/json",
  //    })
  //  };

  //  return this._http.request("post", url_, options_);


  ////  return this._http.request("post", url_, options_).pipe(map((res: any) => {
  ////    return new Blob([res.body], {
  ////      type: 'application/pdf'
  ////    });
  ////  }));
  //}


}
